'use client'

import { Typography } from '@mui/material'

const ModeDropdown = ({ dataSession }: { dataSession: any }) => {
  return (
    <>
      <div className='flex flex-col items-start'>
        <Typography variant='h6' fontWeight='bold' color='white' sx={{ fontSize: '2.5vh' }}>
          {'TMC ETERNAL HOME'}
        </Typography>
        <Typography variant='body2' fontWeight='bold' color='white' sx={{ fontSize: '2vh' }}>
          {'JL. KH. Lukman Hakim, RT.02/RW.10, Tuguraja, Kec.Cihideung, Kota Tasikmalaya, Jawa Barat 46125'}
        </Typography>
      </div>
    </>
  )
}

export default ModeDropdown
